import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks';
import { MotionContainer } from './Styles';
import { formatCurrency } from '../shared/utils/common';

const BlockStatus = ({ screen }) => {
  const {
    AuctionStore: { connected },
    BidStore: {
      auction: {
        statusBgColor, statusColor, blockStatus, flashBgColor, flashColor, winningBidderName, winningBidderNumber, currentBid, nextBid, tempBlockStatus,
      }, isFloorBidderBid,
    },
    MessageStore: { systemMessage },
  } = useStores();

  let keyGen;
  const getVariants = () => ({
    default: {
      transition: { delay: 0.1 },
      backgroundColor: statusBgColor,
      color: statusColor,
    },
    flash: {
      transition: { duration: '1.25' },
      backgroundColor: flashBgColor ?? statusBgColor,
      color: flashColor ?? statusColor,
    },
    error: {
      backgroundColor: 'red',
      color: 'white',
    },
  });
  
  const getBlockStatus = () => {
    if (screen === 'Auctioneer') {
      if (currentBid === 0 && nextBid > currentBid) return `Asking Bid: $ ${formatCurrency(nextBid)}`;
    }

    // if a floor or online bid (screens see info a bit differently)
    if (isFloorBidderBid) {
      if (screen === 'Auctioneer') {
        return winningBidderName?.toUpperCase();
      }
      return blockStatus;
    }

    if (!isFloorBidderBid) {
      if (screen === 'Auctioneer') {
        if (blockStatus?.indexOf('Currently') > -1) return blockStatus;
        if (winningBidderName) {
          return `${winningBidderName?.toUpperCase()} (${winningBidderNumber})`;
        }
      }
    }

    // all else
    return blockStatus;
  };

  const isBidIncrementStatusOnAuctioneer = screen === 'Auctioneer' && tempBlockStatus?.indexOf('Increment') > -1;
  if (tempBlockStatus && !isBidIncrementStatusOnAuctioneer) {
    return (
      <MotionContainer
        initial="default"
        animate="default"
        exit="default"
        variants={getVariants()}
        data-testid="block-status"
        className="blockStatus"
        key={Math.random()}
        disabled={!connected}
      >
        <h2>{tempBlockStatus}</h2>
      </MotionContainer>
    );
  }

  if (systemMessage) {
    return (
      <MotionContainer
        isSystemMessage={systemMessage}
        initial="error"
        animate="error"
        exit="error"
        variants={getVariants()}
        data-testid="block-status"
        className="blockStatus"
        key={Math.random()}
        disabled={false}
      >
        <h2>{systemMessage.message}</h2>
      </MotionContainer>
    );
  }

  const noFlash = isBidIncrementStatusOnAuctioneer;

  if (!noFlash) keyGen = Math.random();
  return (
    <MotionContainer
      initial={noFlash ? "default" : "flash"}
      animate="default"
      exit={noFlash ? "default" : "flash"}
      variants={getVariants()}
      data-testid="block-status"
      className="blockStatus"
      key={keyGen}
      disabled={!connected}
    >
      <h2>{getBlockStatus()}</h2>
    </MotionContainer>
  );

};

BlockStatus.propTypes = {
  screen: PropTypes.string,
};

BlockStatus.defaultProps = {
  screen: null,
};

export default observer(BlockStatus);
